import React, {useEffect, useState} from "react";
import {Typography, Modal, FormControl, InputLabel, OutlinedInput} from '@mui/material';
import { useForm, Controller  } from "react-hook-form";

import ButtonMain from "../button/Button_main";
import './Modal_style.scss'

const ModalRejectComment = (props) => {

    const [jobReq, setJobReq] = useState({})
    const {register, handleSubmit, control, formState: { errors }, setValue} = useForm();
    


    const cancel = () => {
        props.setOpenRejectModal()
    }

    const submit = (data) => {
        const {reason} = data
        console.log('reject reason', reason)
        props.rejectSingle(props.rejectData.id, reason)
    }

    useEffect(()=>{
        if(!props.openRejectModal) setValue('reason', '');
    },[props.openRejectModal])

    return(
            <Modal
                open={props.openRejectModal}
               // onClose={()=>props.setOpenJobView(false)}
                aria-labelledby="modal-modal-title"
            >   
                <div className="modal-container modal-view">
                    <>  
                        <Typography id="modal-modal-title" variant="textheader3" className="mb-2-modal" component="div">
                            Add Rejection Reason
                        </Typography>
                        <Typography id="modal-modal-title"  className="" variant="textBaseLight" component="div">
                            Applicant Name : <span className="modal-text-primary">{ props.rejectData.name ? props.rejectData.name : '-'}</span> 
                            { props.rejectData.rate ? (
                            <>                       
                                <span className="px-2-modal">|</span> 
                                Match : <span className="modal-text-primary">{props.rejectData.rate ? props.rejectData.rate : '-'}</span> 
                            </>
                        ):''}
                        </Typography>
                        <div className="border-bottom-modal mb-5-modal"></div>
                        <form onSubmit={handleSubmit(data => submit(data))}>
                            <FormControl fullWidth variant="standard">
                                <div className="flex justify-between">
                                    <InputLabel shrink htmlFor="reason">Reason</InputLabel>
                                </div>
                                <OutlinedInput
                                    id="reason"
                                    placeholder="Enter rejection reason.."
                                    type='text'
                                    multiline
                                    rows={4}
                                    className="p-0"
                                    {...register("reason" )}
                                />
                            </FormControl>
                        <div className="modal-footer-right mt-5-modal pt-5-modal border-top-modal">
                            <ButtonMain 
                                variant='primaryOutline' 
                                type='button' 
                                disabled={false} 
                                name='Cancel'
                                class='modal-capitalize mr-4'
                                onClick={cancel}
                            />
                            <ButtonMain 
                                variant='red' 
                                type='submit' 
                                disabled={false} 
                                name={props.autoEmail ? `Reject & Reply` : 'Reject'}
                                class='capitalize mr-3'
                                onClick={() => {}}
                            />
                        </div>
                        </form>
                    </>
                </div>
                
            </Modal>
    )
}

export default ModalRejectComment;